import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3347 0.333374L1.26218 0.337065C0.741703 0.390663 0.475142 1.01605 0.82565 1.43052L6.00136 7.55071V11.6667C6.00136 11.9192 6.14403 12.1501 6.36989 12.263L9.03655 13.5963L9.10711 13.6269C9.53328 13.7836 10.0014 13.4695 10.0014 13V7.55004L15.1771 1.43052C15.5435 0.997209 15.2355 0.333374 14.668 0.333374H1.3347ZM13.2314 1.66671L8.82565 6.87622L8.77017 6.95208C8.70377 7.05779 8.66803 7.18062 8.66803 7.30671V11.9214L7.3347 11.2547V7.30671L7.32807 7.21297C7.31052 7.08937 7.2585 6.9725 7.17708 6.87622L2.7707 1.66671H13.2314Z"
        fill="white"
      />
    </Svg>
  );
};

export default Icon;
